export default {
      id: "ic_watch_stack_circle-usage",
      viewBox: "0 0 15 15",
      url: "/" + "images/icons.3.109.2.svg#ic_watch_stack_circle-usage",
      toString: function () {
        return this.url;
      }
    }